import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect } from 'react';
import Utils from '../../utils';
import FilePreviewFrame from './FilePreviewFrame';
import { Link } from '@material-ui/core';
var useStyles = makeStyles(function () {
  return {
    ticketLabel: {
      display: 'inline-block',
      maxWidth: '100%',
      marginBottom: 5,
      color: '#777777',
      fontWeight: 'normal'
    },
    ticketMeta: {
      color: '#777777',
      backgroundColor: '#F7F7F7',
      padding: 28,
      textAlign: 'left'
    },
    ticketItem: {
      marginBottom: 10
    }
  };
});

var EmailBodyPreview = function EmailBodyPreview(_ref) {
  var workspace = _ref.workspace,
      path = _ref.path;
  var frameRef = React.useRef(null);

  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      src = _React$useState2[0],
      setSrc = _React$useState2[1];

  var _React$useState3 = React.useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      error = _React$useState4[0],
      setError = _React$useState4[1];

  var _React$useState5 = React.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      ticket = _React$useState6[0],
      setTicket = _React$useState6[1];

  var classes = useStyles();
  useEffect(function () {
    Utils.apiClients.tags.getTags(workspace, path).then(function (tags) {
      var ticketTag = tags.find(function (tag) {
        return tag.Name === 'ticket-id';
      });
      if (!ticketTag) return;
      Utils.apiClients.tickets.getTicket(ticketTag.Value).then(function (ticket) {
        if (!ticket) setError('Missing ticket');else setTicket(ticket);
      });
    });
    Utils.apiClients.files.getResourceToken(workspace, path).then(function (resourceToken) {
      var htmlSrc = "".concat(Utils.getHost(), "backend/preview?resourceToken=") + encodeURIComponent(resourceToken) + '&workspace=' + encodeURIComponent(workspace) + '&path=' + encodeURIComponent(path) + '&type=reader&' + new Date().getTime();
      setSrc(htmlSrc);
    });
  }, [workspace, path]);

  var onLinkClicked = function onLinkClicked(event, attachment) {
    event.preventDefault();
    Utils.apiClients.files.getResourceToken(workspace, path).then(function (resourceToken) {
      window.open("".concat(Utils.getHost(), "backend/content?resourceToken=") + resourceToken + '&workspace=' + encodeURIComponent(workspace) + '&path=' + encodeURIComponent(attachment.Path) + '&version=-1&inline=false' + '&fileName=' + attachment.Name, '_self', '');
    });
  };

  var oniFrameLoaded = function oniFrameLoaded() {
    if (!frameRef.current) return;
    var frameDocument = frameRef.current.contentWindow.document;
    var frameBody = frameDocument.body;
    frameRef.current.height = frameBody.scrollHeight + 16;
    frameRef.current.width = frameBody.scrollWidth + 16;
    frameBody.style.fontFamily = 'Source Sans Pro,Calibri,Candara,Arial,sans-serif';
    var anchors = frameBody.querySelectorAll('a');

    for (var idx = 0; idx < anchors.length; idx++) {
      anchors[idx].setAttribute('target', '_blank');
    }
  };

  if (!src) return null;
  return React.createElement(FilePreviewFrame, null, React.createElement(Grid, {
    container: true,
    direction: "column",
    className: classes.ticketMeta
  }, React.createElement(Grid, {
    item: true,
    className: classes.ticketItem
  }, React.createElement(Typography, {
    className: classes.ticketLabel
  }, "To"), React.createElement("div", null, ticket && ticket.To || '-')), React.createElement(Grid, {
    item: true,
    className: classes.ticketItem
  }, React.createElement(Typography, {
    className: classes.ticketLabel
  }, "From"), React.createElement("div", null, ticket && ticket.From || '-')), React.createElement(Grid, {
    item: true,
    className: classes.ticketItem
  }, React.createElement(Typography, {
    className: classes.ticketLabel
  }, "Subject"), React.createElement("div", {
    style: {
      fontSize: 20
    }
  }, ticket && ticket.Subject || '-')), ticket && ticket.Attachments.length && React.createElement(Grid, {
    item: true,
    className: classes.ticketItem
  }, React.createElement("div", null, React.createElement(Typography, {
    className: classes.ticketLabel
  }, "Attachments")), ticket.Attachments.map(function (attachment) {
    return React.createElement(Link, {
      href: "#",
      onClick: function onClick(event) {
        return onLinkClicked(event, attachment);
      }
    }, attachment.Name);
  }))), React.createElement(Grid, {
    container: true
  }, React.createElement("iframe", {
    ref: frameRef,
    onLoad: oniFrameLoaded,
    style: {
      border: 'none',
      minWidth: '600px'
    },
    src: src,
    sandbox: "allow-popups allow-scripts allow-same-origin"
  })));
};

export default EmailBodyPreview;